import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M15.9616 10.2269C15.9612 10.2271 15.9608 10.2277 15.9604 10.228L12.1621 13.941C12.1621 13.941 12.1621 13.941 12.1617 13.941C12.1497 13.9527 12.1349 13.9636 12.1173 13.9727C12.0281 14.019 11.9029 14.005 11.8381 13.941H11.8377L8.03774 10.2269C7.97335 10.1629 7.99335 10.0737 8.08254 10.0271C8.11814 10.0089 8.15934 10 8.20014 10H15.8C15.8408 10 15.882 10.0089 15.9176 10.0271C16.0068 10.0737 16.0268 10.1629 15.9616 10.2269V10.2269Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'DropDown');

export default Icon;
